import React, { useEffect } from 'react';
import { S3_CONFIG } from '../../config/config';
import CardMedia from '@mui/material/CardMedia';
import { CircularProgress, Box } from '@mui/material';

interface AsyncImageProps {
  url: string;
  w?: number;
  h?: number;
  isPopUp?: boolean;
}

export const AsyncImage = (props: AsyncImageProps) => {
  const { url: key, w, h , isPopUp} = props;

  const [url, setUrl] = React.useState<string | null>(null);
  const [imageUrl, setImageUrl] = React.useState<string>('/no-image-found.png');
  const [isLoading, setIsLoading] = React.useState(true);
  const [isDefaultImage, setIsDefaultImage] = React.useState(true);

  useEffect(() => {
    if (!url) {
      setImageUrl('/no-image-found.png');
      setIsDefaultImage(true);
      setIsLoading(false);
    } else {
      setImageUrl(url.trim());
      setIsDefaultImage(false);
    }
  }, [url]);

  const getImageName = (url: string) => {
    const parts = url.split('/');
    let imageName = parts[parts.length - 1];
    return imageName.replace(/\?.+/,"");
  }

  useEffect(() => {
    setIsLoading(true);
    (async () => {
      if (!key) {
        setIsLoading(false);
        return;
      }
      const url = await getS3FileUrl(key);
      setImageUrl(url);
    })(); //IIFE!
  }, []);

  const getS3FileUrl = async (key: string) => key.replace(`${S3_CONFIG.amazon_host}`, S3_CONFIG.cdn_host);

  const handleImageLoad = () => {
    setIsLoading(false);
  };

  const handleImageError = () => {
    setIsLoading(false);
    setImageUrl('/no-image-found.png');
    setIsDefaultImage(true);
  };

  return (
    <Box
      sx={{
        position: 'relative',
        width: w ? w : '400px',
        height: h ? h : '400px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      {isLoading && (
        <CircularProgress
          size={25}
          sx={{
            position: 'absolute',
            zIndex: 1,
            fontSize: '20px'
          }}
        />
      )}
      <CardMedia
        component="img"
        sx={{
          width: isDefaultImage ? w?? '100px': '100%',
          height: isDefaultImage ? h?? '100px' : '100%',
          flex: '1 0 auto',
          objectFit: 'contain',
          opacity: isLoading ? 0.5 : 1,
          transition: 'all 0.3s'
        }}
        image={imageUrl}
        alt="Product Image"
        loading="lazy"
        onLoad={handleImageLoad}
        onError={handleImageError}
      />
    {/*  Render the image name below */}
      {isPopUp && (
        <a style={{
          position: 'relative',
          textAlign: 'center',
        }} href={imageUrl}>{getImageName(imageUrl)}</a>
        )}
    </Box>
  );
};
